import { ithacaInit } from '@dtx-company/ithaca-sdk/src'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import configuration from '@dtx-company/true-common/src/constants/config'

export function useIthacaInitialization(): void {
  const dispatch = useDispatch()
  useEffect(() => {
    ithacaInit({
      firebase: configuration.firebase,
      sso: { jwt: undefined }
    })
  }, [dispatch])
}
